import clsx from 'clsx'
import styles from './styles/discontinuedTag.module.scss'

const DiscontinuedTag = ({ className = '', children }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={clsx(styles.discontinuedTag, className)}>{children ?? 'DISCONTINUED'}</div>
)

export default DiscontinuedTag
